import { EventEmitter } from '@angular/core';

export interface TabItem {
  tabDescription: string;
  tabId: string | number;
  url?: string;
}

export interface TabNavigation {
  selectedTabIndex: number;
  tabList: TabItem[];
  selectedTab: EventEmitter<TabItem>;

  notifyTabSelection(event: Event, tabItem: TabItem, index: number): void;

  setSelectedTab(index: number): void;
}
